import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Helmet from 'react-helmet';
import styled, { css } from 'styled-components';
import { toggleNavDrawer, toggleCartModal } from 'ducks/ui';
import { theme } from 'styles';
import { IconPlatform } from 'icons';
import { iconCartSvg, iconPhoneSvg } from 'images';
import routes from 'helpers/routes';
import { MainNav, IconLink } from 'components/shared';
import { Overlay, Header } from './components';

// prettier-ignore
const StyledNavDrawer = styled.div`
  position: fixed;
  top: 0;
  left: -9999px;
  bottom: 0;
  z-index: ${theme.zIndices.NavDrawer};
  transition: all 0.3s, left 0s 0.3s;
  transform: translateX(-100%);
  background-color: ${theme.colors.white};
  width: 18.75em;
  max-width: 100%;
  overflow-y: scroll;
  overflow-x: hidden;

  ${props => props.isOpen && css`
    transition: all 0.3s, left 0s;
    left: 0;
    transform: translateX(0);
  `};
`;

const Wrapper = styled.div`
  padding: 0 24px 60px;
`;

const Section = styled.div`
  margin-bottom: ${theme.sp.m};
  border-bottom: 1px solid ${theme.colors.border};
`;

const propTypes = {
  isOpen: PropTypes.bool.isRequired,
  closeDrawer: PropTypes.func.isRequired,
  openCart: PropTypes.func.isRequired,

  // Pass-through prop, we don't care what it is
  // eslint-disable-next-line react/forbid-prop-types
  productCategories: PropTypes.any.isRequired,
};

function NavDrawer({ isOpen, closeDrawer, openCart, productCategories }) {
  return (
    <div>
      <Helmet
        bodyAttributes={{
          class: isOpen ? 'nav-drawer-is-open' : '',
        }}
      />

      <Overlay onClick={closeDrawer} isOpen={isOpen} />

      <StyledNavDrawer isOpen={isOpen}>
        <Wrapper>
          <Header onClose={closeDrawer} />

          <Section>
            <MainNav vertical productCategories={productCategories} />
          </Section>

          <div>
            <IconLink
              external
              href={`${process.env.GATSBY_MARKETTAP_PLATFORM_CLIENT_HOST}`}
            >
              <IconPlatform />
              Platform
            </IconLink>
          </div>

          <div>
            <IconLink
              onClick={() => {
                closeDrawer();
                openCart();
              }}
            >
              <img src={iconCartSvg} alt="Cart" />
              Cart
            </IconLink>
          </div>

          <div>
            <IconLink to={routes.bookMarketer.index}>
              <img src={iconPhoneSvg} alt="Book a Call" />
              Book a Call
            </IconLink>
          </div>
        </Wrapper>
      </StyledNavDrawer>
    </div>
  );
}

NavDrawer.propTypes = propTypes;

const mapStateToProps = state => ({ isOpen: state.ui.isNavDrawerOpen });
const mapDispatchToProps = {
  closeDrawer: toggleNavDrawer,
  openCart: toggleCartModal,
};
export default connect(mapStateToProps, mapDispatchToProps)(NavDrawer);



// WEBPACK FOOTER //
// ./src/components/shared/NavDrawer/NavDrawer.jsx